<template>
  <div>
    <Filters
      :status="currentStatus"
      @change="updateFilters"
    />

    <Table
      :items="items"
      :pagination="pagination"
      :status="currentStatus"
      @reloadData="reloadData"
      @goToPage="updatePage"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray } from 'utils/functions'
import Filters from './Filters'
import Table from './Table'

export default {
  name: 'IncentivesPage',
  components: {
    Filters,
    Table
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.IncentivesPage',
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      filters: {
        referenceId: null,
        type: null,
        createdBy: null
      },
      currentStatus: null,
      items: []
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    updatePagination (response, itemsPerPage) {
      this.pagination = {
        ...this.pagination,
        totalElements: response.totalElements,
        totalPages: response.totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.reloadData()
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    async loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const { referenceId, type, createdBy } = this.filters
        const { data: res } = await this.$apiService.incentives.getActives(
          { page: currentPage - 1 },
          { size: itemsPerPage },
          { referenceId },
          { type },
          { createdBy }
        )

        this.items = res && this.isValidArray(res.content) ? res.content : []
        this.updatePagination(res, itemsPerPage)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    }
  },

  mounted () {
    this.reloadData()
  }
}
</script>
